import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Loading } from 'components/atoms/loading';
import { getStatusUpdates, selectStatusLoading } from 'data/status-updates';
import { StatusUpdatesContainer } from './status-updates-content';
import styles from './status-updates.module.css';

export const StatusUpdatesPage = (): JSX.Element => {
  const dispatch = useDispatch();
  const isLoading = useSelector(selectStatusLoading);
  const { projectId } = useParams<{ projectId: string }>();

  useEffect(() => {
    if (!isLoading) {
      return;
    }
    dispatch(
      getStatusUpdates({
        projectId: parseInt(projectId, 10),
      }),
    );
  }, [dispatch, isLoading, projectId]);

  return isLoading ? (
    <div className={styles.container}>
      <Loading />
    </div>
  ) : (
    <StatusUpdatesContainer />
  );
};
